// Filtros do painel societário, mantidos por alguns minutos após o refresh
// (usePersistedFilters, por escritório/usuário/página).
export var SOCIETARIO_FILTERS_KEY = 'societario.painel';

// Chave antiga: localStorage sem prazo e sem escritório/usuário. Apagada uma vez.
export var LEGACY_SOCIETARIO_FILTERS_KEY = 'societario_filtros';

// Por quantos dias uma tarefa concluida continua na coluna "Concluido".
// A coluna acumulava tudo que a API devolvia — no ambiente analisado eram 192
// cards concluidos contra 23 em aberto, e o arquivamento praticamente nao e
// usado. O padrao de 90 dias mantem o historico recente a vista sem enterrar o
// trabalho que ainda importa.
export var DONE_PERIODS = [
  { value: 30, label: 'Últimos 30 dias' },
  { value: 90, label: 'Últimos 90 dias' },
  { value: 180, label: 'Últimos 180 dias' },
  { value: 0, label: 'Todos' },
];

export var DEFAULT_DONE_PERIOD = 90;

// "Parado há mais de X dias": sem nenhuma etapa marcada nesse intervalo.
export var STALE_PERIODS = [
  { value: 0, label: 'Qualquer' },
  { value: 7, label: '7+ dias' },
  { value: 15, label: '15+ dias' },
  { value: 30, label: '30+ dias' },
];

var SCREENS = ['active', 'archived'];

var isKnown = function(options, value) {
  return options.some(function(option) { return option.value === value; });
};

export var getDefaultSocietarioFilters = function() {
  return {
    screen: 'active',
    donePeriod: DEFAULT_DONE_PERIOD,
    stageFilter: null,
    staleDays: 0,
    search: '',
  };
};

// Valores salvos desconhecidos (outra versão, edição manual) voltam ao padrão.
export var normalizeSocietarioFilters = function(filters) {
  var f = filters || {};
  return {
    screen: SCREENS.indexOf(f.screen) >= 0 ? f.screen : 'active',
    donePeriod: isKnown(DONE_PERIODS, f.donePeriod) ? f.donePeriod : DEFAULT_DONE_PERIOD,
    stageFilter: typeof f.stageFilter === 'string' && f.stageFilter ? f.stageFilter : null,
    staleDays: isKnown(STALE_PERIODS, f.staleDays) ? f.staleDays : 0,
    search: typeof f.search === 'string' ? f.search : '',
  };
};

// Badge: só o que difere do padrão e vale na tela atual. Na tela de
// arquivados só a própria tela filtra (etapa, parados, período e busca não se
// aplicam à tabela de arquivados).
export var countActiveSocietarioFilters = function(filters, defaults) {
  if (filters.screen !== defaults.screen) return 1;
  return (filters.donePeriod !== defaults.donePeriod ? 1 : 0) +
    (filters.stageFilter ? 1 : 0) +
    (filters.staleDays ? 1 : 0) +
    (filters.search ? 1 : 0);
};

export var removeLegacySocietarioFilters = function() {
  try {
    window.localStorage.removeItem(LEGACY_SOCIETARIO_FILTERS_KEY);
  } catch (error) {
    // localStorage indisponivel (navegacao anonima): nada a apagar
  }
};

var findLabel = function(options, value) {
  for (var i = 0; i < options.length; i++) {
    if (options[i].value === value) return options[i].label;
  }
  return String(value);
};

// Texto curto dos filtros fora do padrão, para o aviso de filtros mantidos.
export var getSocietarioFiltersSummary = function(filters, defaults, stageOptions) {
  if (filters.screen !== defaults.screen) return 'Arquivados';
  var parts = [];
  if (filters.donePeriod !== defaults.donePeriod) {
    parts.push('Concluídos: ' + findLabel(DONE_PERIODS, filters.donePeriod).toLowerCase());
  }
  if (filters.stageFilter) {
    var stage = null;
    var options = stageOptions || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i].key === filters.stageFilter) stage = options[i];
    }
    parts.push('Etapa da vez: ' + (stage ? stage.short : filters.stageFilter));
  }
  if (filters.staleDays) parts.push('Parados há ' + filters.staleDays + '+ dias');
  if (filters.search) parts.push('Busca: ' + filters.search);
  return parts.join(' · ');
};
